var collab = new Object();

function checkcollabClick(){



    var formValid = true;

    if (document.getElementById("collab-form-fname").value.length < 1) {
        formValid = false;
        document.getElementById("collab-form-fname").classList.add("input--error");
    } else {
        collab.firstName = document.getElementById("collab-form-fname").value;
    }


    if (document.getElementById("collab-form-lname").value.length < 1) {
        formValid = false;
        document.getElementById("collab-form-lname").classList.add("input--error");

    } else {
        collab.lastName = document.getElementById("collab-form-lname").value;
    }


    if (document.getElementById("collab-form-email").value.length < 1) {
        formValid = false;
        document.getElementById("collab-form-email").classList.add("input--error");

    } else {
        collab.email = document.getElementById("collab-form-email").value;

    }

    if (validateEmail(document.getElementById("collab-form-email").value) === false) {
        formValid = false;
        document.getElementById("collab-form-email").classList.add("input--error");

    }

    
    if (document.getElementById("collab-address-1").value.length < 1) {
        formValid = false;
        document.getElementById("collab-address-1").classList.add("input--error");
    } else {
        collab.address1 = document.getElementById("collab-address-1").value;
    }

    
    if (document.getElementById("collab-address-2").value.length > 0) {

        collab.address2 = document.getElementById("collab-address-2").value;
    } else {
        collab.address2 = "";
    }

    
    if (document.getElementById("collab-city").value.length < 1) {
        formValid = false;
        document.getElementById("collab-city").classList.add("input--error");
    } else {
        collab.city = document.getElementById("collab-city").value;
    }

    collab.country = document.getElementById("collab-country").value;

    if(collab.country == "United States"){
        collab.state = document.getElementById("collab-state").value;
    }
    else if (collab.country == "Canada"){
        collab.state = document.getElementById("collab-canada-state").value;
    }


    
    if (document.getElementById("collab-zip").value.length < 1) {
        formValid = false;
        document.getElementById("collab-zip").classList.add("input--error");
    } else {
        collab.zip = document.getElementById("collab-zip").value;
    }

    
    if (document.getElementById("collab-phone").value.length < 1) {
        formValid = false;
        document.getElementById("collab-phone").classList.add("input--error");
    } else {
        collab.phone = document.getElementById("collab-phone").value;
    }

      
      if (document.getElementById("collab-birthday").value.length < 1) {
        formValid = false;
        document.getElementById("collab-birthday").classList.add("input--error");
    } else {
        collab.birthday = document.getElementById("collab-birthday").value;
    }





    if (document.getElementById("collab-form-ig").value == "") {
        document.getElementById("collab-form-ig").classList.add("input--error");
       
        formValid = false;

    } else {
        collab.ig = document.getElementById("collab-form-ig").value;
        collab.fb = document.getElementById("collab-form-fb").value;
        collab.blog = document.getElementById("collab-form-blog").value;
        collab.yt = document.getElementById("collab-form-yt").value;
        collab.pinterest = document.getElementById("collab-form-pinterest").value;
        collab.tiktok = document.getElementById("collab-form-tiktok").value;

    }



    if (document.getElementById("collab-form-ltk").value === null) {
        formValid = false;
        document.getElementById("collab-form-ltk").classList.add("input--error");
    } else {
        collab.listrakLinks = document.getElementById("collab-form-ltk").value;
    }







    if (formValid === true) {

        collab.dept = "8";

        const xhr = new XMLHttpRequest();
        // Set up the request
xhr.open("POST", "https://api.pinkblushmaternity.com/api/Collab/SubmitCollab_V2", true);
xhr.setRequestHeader("Content-Type", "application/json");

// Send the request
xhr.send(JSON.stringify(collab));

// Event handler for success
xhr.onload = function () {
  if (xhr.status === 200) {
    document.getElementsByClassName("collab-success")[0].innerHTML = "<b>Thank you for applying!</b><br/> We will be in touch shortly.  If you have any questions, please email us at <a href='mailto:media@brandsie.com'>media@brandsie.com</a>."
    document.getElementsByClassName("collab-form-wrapper")[0].classList.add("hide");
    document.getElementsByClassName("collab-success")[0].classList.remove("hide");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  } else {
    document.getElementsByClassName("collab-error")[0].innerHTML = "An error has occurred.Please reach out to media@brandsie.com to apply!";
    document.getElementsByClassName("collab-error")[0].classList.remove("hide");
}
}

// Event handler for error
xhr.onerror = function () {
  console.error("Request failed:", xhr.statusText);
};

} 
    else {
        document.getElementsByClassName("collab-error")[0].innerHTML = "Please check the highlighted fields and try again!";
        document.getElementsByClassName("collab-error")[0].classList.remove("hide");

    }

    return false;


}

document.addEventListener("DOMContentLoaded", () => {



    document.getElementById("collab-form-fname").addEventListener("input",function () {
        document.getElementById("collab-form-fname").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";

    });

    document.getElementById("collab-form-lname").addEventListener("input",function () {
        document.getElementById("collab-form-lname").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-form-email").addEventListener("input",function () {
        document.getElementById("collab-form-email").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

   

    document.getElementById("collab-address-1").addEventListener("input",function () {
        document.getElementById("collab-address-1").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-address-2").addEventListener("input",function () {
        document.getElementById("collab-address-2").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-city").addEventListener("input",function () {
        document.getElementById("collab-city").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-zip").addEventListener("input",function () {
        document.getElementById("collab-zip").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });
    document.getElementById("collab-phone").addEventListener("input",function () {
        document.getElementById("collab-phone").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });


    document.getElementById("collab-birthday").addEventListener("change",function () {
        document.getElementById("collab-birthday").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });


   

    document.getElementById("collab-form-ltk").addEventListener("input",function () {
        document.getElementById("collab-form-ltk").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    
    document.getElementById("collab-form-ig").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-form-blog").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-form-fb").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    document.getElementById("collab-form-pinterest").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide")

        document.getElementsByClassName("collab-error")[0].innerHTML = "";
    });
    document.getElementById("collab-form-tiktok").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";



    });
    document.getElementById("collab-form-yt").addEventListener('input', (e) => {
        document.getElementById("collab-form-ig").classList.remove("input--error");
        document.getElementById("collab-form-fb").classList.remove("input--error");
        document.getElementById("collab-form-blog").classList.remove("input--error");
        document.getElementById("collab-form-yt").classList.remove("input--error");
        document.getElementById("collab-form-tiktok").classList.remove("input--error");

        document.getElementById("collab-form-pinterest").classList.remove("input--error");
        document.getElementsByClassName("collab-error")[0].classList.add("hide");
        document.getElementsByClassName("collab-error")[0].innerHTML = "";


    });

    



    document.getElementById("collab-country").addEventListener("change",function () {
        let value = this.value;
        if (value == "United States") {
            document.getElementById("collab-state").classList.remove("hide");
            document.getElementById("collab-canada-state").classList.add("hide");
        } else {
            document.getElementById("collab-state").classList.add("hide");
            document.getElementById("collab-canada-state").classList.remove("hide");
        }
    });

});

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };